import type { ReactNode } from 'react';
import styled from '@emotion/styled';
import * as tokens from '@tokens';

export interface TabPanelProps {
  /**
   * Content of the panel.
   */
  children: ReactNode;
  /**
   * Styles override.
   */
  className?: string;
  /**
   * Indicates if panel should be rendered.
   */
  isVisible: boolean;
}

const Panel = styled('div')`
  padding: ${tokens.spacer.x3};
`;

/**
 * TabPanel contains the content to be displayed for the selected tab.
 *
 * {@link https://zeroheight.com/76c439891/p/1901d5-tabs Usage guidelines}
 *
 * {@link https://storybook.hotjar.com/?path=/docs/components-tabs Code documentation}
 *
 * @example
 * <Tabs.Panel isVisible={...}>Content</Tabs.Panel>
 */
export const TabPanel = ({
  children,
  className,
  isVisible,
}: TabPanelProps): JSX.Element => {
  if (!isVisible) {
    return null;
  }

  return <Panel className={className}>{children}</Panel>;
};

TabPanel.defaultProps = {
  isVisible: false,
};
